import { default as aboutl1eqSSODWSMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsjbOs6rbTMTMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93AysJSvWBNQMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleVhkm5NGJFRMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsl3DZfLji9oMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93wFHBCByvgQMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewsS5c4Dr0FlMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexsqiAJvFsgoMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93yxzsTDlVAVMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexjZQ68KLYi4Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93oZTs25ykp8Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexTigBGjGt6pMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionshsUhNFy7fYMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordings5sNunPdv5MMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsG63TstmJbqMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93i2sf1ZM2uRMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as index5Es4OQvE0hMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmGsIbPEDXLQMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmRVyYIWLyR1Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendarKT6dumAsKlMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatkJfwyQ6eYVMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/chat.vue?macro=true";
import { default as abouttbGWnYt4zGMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feed67fex4McdwMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as members7YbNs4BY4IMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93RucVDvV7AWMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editQEzhAHhKolMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93eR1EVmDN7qMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communityDPzBhoFs3rMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93mVTTTX3mLoMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_937iz1DsLtHdMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardeYD7KlgmvRMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/dashboard.vue?macro=true";
import { default as index4lORKlFOthMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutYKHrWFyUQnMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productsfAxuzVWshMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsj4aViZf72UMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93CqbVZq0IxSMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexGg6gIcMm8fMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93hPSKtLo6kOMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_938jeZFQLGgJMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexXrRj4qsflmMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93MKaT8LNQkUMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joingXzqQKG3RiMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/join.vue?macro=true";
import { default as loginyzzPRVXq9RMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/login.vue?macro=true";
import { default as logoutUIflEFpIHeMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93TKH1HPUyNtMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93pknFv9nzPCMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93MCTrRRgsuoMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favoritesBCJwDKblt9Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studios3PaVj4A80GMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optin4yTwwOkDYGMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_935DspaXXHoDMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexalJQC5pwy5Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as indexsZQnbSeeBEMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutrCaMzfsNVHMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentudXFiUQ3mhMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as events4U6Db5nyvrMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93KoAH2D23aEMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleVqI7q9YgXLMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsXfvIAcT4AKMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93Q0AJz1FjfWMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewGJIjzGYXvaMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexauZh1NbPBoMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93iIA8gAyGOeMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexhfgXg3LFa9Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93gBGPbamUcqMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index11O1lSxDKcMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsyna80S6NxEMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsgyuxGGeX8cMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewsC5RF2ip1XAMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93J108071pefMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexV1EeS9Hd2sMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexbgngeomjnfMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesr7oZrAzr8gMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptions1PNAbFbbMNMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93dgPrZg83ICMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_93AiLfrqyh9LMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetI0WxsnQoNCMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/reset.vue?macro=true";
import { default as shopBi6fA9lxDtMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/shop.vue?macro=true";
import { default as signupBKyjn8Gi5dMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/signup.vue?macro=true";
import { default as liveAT48POuDjZMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipsN0u4O29FjtMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93diuEmgQFeoMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactH1bMVuDzrfMeta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullziN9pvRiN8Meta } from "/tmp/build_d5a8d3bb/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93i2sf1ZM2uRMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93i2sf1ZM2uRMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93i2sf1ZM2uRMeta || {},
    alias: _91product_id_93i2sf1ZM2uRMeta?.alias || [],
    redirect: _91product_id_93i2sf1ZM2uRMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutl1eqSSODWSMeta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: aboutl1eqSSODWSMeta?.path ?? "about",
    meta: aboutl1eqSSODWSMeta || {},
    alias: aboutl1eqSSODWSMeta?.alias || [],
    redirect: aboutl1eqSSODWSMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsjbOs6rbTMTMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsjbOs6rbTMTMeta?.path ?? "events",
    meta: eventsjbOs6rbTMTMeta || {},
    alias: eventsjbOs6rbTMTMeta?.alias || [],
    redirect: eventsjbOs6rbTMTMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93AysJSvWBNQMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_93AysJSvWBNQMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93AysJSvWBNQMeta || {},
    alias: _91media_id_93AysJSvWBNQMeta?.alias || [],
    redirect: _91media_id_93AysJSvWBNQMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleVhkm5NGJFRMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleVhkm5NGJFRMeta?.path ?? "free-sample",
    meta: free_45sampleVhkm5NGJFRMeta || {},
    alias: free_45sampleVhkm5NGJFRMeta?.alias || [],
    redirect: free_45sampleVhkm5NGJFRMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsl3DZfLji9oMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsl3DZfLji9oMeta?.path ?? "included-products",
    meta: included_45productsl3DZfLji9oMeta || {},
    alias: included_45productsl3DZfLji9oMeta?.alias || [],
    redirect: included_45productsl3DZfLji9oMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93wFHBCByvgQMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93wFHBCByvgQMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93wFHBCByvgQMeta || {},
    alias: _91media_id_93wFHBCByvgQMeta?.alias || [],
    redirect: _91media_id_93wFHBCByvgQMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewsS5c4Dr0FlMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewsS5c4Dr0FlMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewsS5c4Dr0FlMeta || {},
    alias: viewsS5c4Dr0FlMeta?.alias || [],
    redirect: viewsS5c4Dr0FlMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexsqiAJvFsgoMeta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: indexsqiAJvFsgoMeta?.path ?? "lessons",
    meta: indexsqiAJvFsgoMeta || {},
    alias: indexsqiAJvFsgoMeta?.alias || [],
    redirect: indexsqiAJvFsgoMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93yxzsTDlVAVMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_93yxzsTDlVAVMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93yxzsTDlVAVMeta || {},
    alias: _91media_id_93yxzsTDlVAVMeta?.alias || [],
    redirect: _91media_id_93yxzsTDlVAVMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexjZQ68KLYi4Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexjZQ68KLYi4Meta?.path ?? "playlists/:playlist_id()",
    meta: indexjZQ68KLYi4Meta || {},
    alias: indexjZQ68KLYi4Meta?.alias || [],
    redirect: indexjZQ68KLYi4Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93oZTs25ykp8Meta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93oZTs25ykp8Meta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93oZTs25ykp8Meta || {},
    alias: _91media_id_93oZTs25ykp8Meta?.alias || [],
    redirect: _91media_id_93oZTs25ykp8Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexTigBGjGt6pMeta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexTigBGjGt6pMeta?.path ?? "playlists",
    meta: indexTigBGjGt6pMeta || {},
    alias: indexTigBGjGt6pMeta?.alias || [],
    redirect: indexTigBGjGt6pMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionshsUhNFy7fYMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionshsUhNFy7fYMeta?.path ?? "private-sessions",
    meta: private_45sessionshsUhNFy7fYMeta || {},
    alias: private_45sessionshsUhNFy7fYMeta?.alias || [],
    redirect: private_45sessionshsUhNFy7fYMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordings5sNunPdv5MMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordings5sNunPdv5MMeta?.path ?? "recordings",
    meta: recordings5sNunPdv5MMeta || {},
    alias: recordings5sNunPdv5MMeta?.alias || [],
    redirect: recordings5sNunPdv5MMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsG63TstmJbqMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewsG63TstmJbqMeta?.path ?? "reviews",
    meta: reviewsG63TstmJbqMeta || {},
    alias: reviewsG63TstmJbqMeta?.alias || [],
    redirect: reviewsG63TstmJbqMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index5Es4OQvE0hMeta?.name ?? "buy-product-product_id",
    path: index5Es4OQvE0hMeta?.path ?? "/buy/product/:product_id()",
    meta: index5Es4OQvE0hMeta || {},
    alias: index5Es4OQvE0hMeta?.alias || [],
    redirect: index5Es4OQvE0hMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmGsIbPEDXLQMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmGsIbPEDXLQMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmGsIbPEDXLQMeta || {},
    alias: confirmGsIbPEDXLQMeta?.alias || [],
    redirect: confirmGsIbPEDXLQMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmRVyYIWLyR1Meta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmRVyYIWLyR1Meta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmRVyYIWLyR1Meta || {},
    alias: confirmRVyYIWLyR1Meta?.alias || [],
    redirect: confirmRVyYIWLyR1Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendarKT6dumAsKlMeta?.name ?? "calendar",
    path: calendarKT6dumAsKlMeta?.path ?? "/calendar",
    meta: calendarKT6dumAsKlMeta || {},
    alias: calendarKT6dumAsKlMeta?.alias || [],
    redirect: calendarKT6dumAsKlMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatkJfwyQ6eYVMeta?.name ?? "chat",
    path: chatkJfwyQ6eYVMeta?.path ?? "/chat",
    meta: chatkJfwyQ6eYVMeta || {},
    alias: chatkJfwyQ6eYVMeta?.alias || [],
    redirect: chatkJfwyQ6eYVMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93RucVDvV7AWMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93RucVDvV7AWMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93RucVDvV7AWMeta || {},
    alias: _91group_id_93RucVDvV7AWMeta?.alias || [],
    redirect: _91group_id_93RucVDvV7AWMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouttbGWnYt4zGMeta?.name ?? "community-groups-group_id-about",
    path: abouttbGWnYt4zGMeta?.path ?? "about",
    meta: abouttbGWnYt4zGMeta || {},
    alias: abouttbGWnYt4zGMeta?.alias || [],
    redirect: abouttbGWnYt4zGMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feed67fex4McdwMeta?.name ?? "community-groups-group_id-feed",
    path: feed67fex4McdwMeta?.path ?? "feed",
    meta: feed67fex4McdwMeta || {},
    alias: feed67fex4McdwMeta?.alias || [],
    redirect: feed67fex4McdwMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: members7YbNs4BY4IMeta?.name ?? "community-groups-group_id-members",
    path: members7YbNs4BY4IMeta?.path ?? "members",
    meta: members7YbNs4BY4IMeta || {},
    alias: members7YbNs4BY4IMeta?.alias || [],
    redirect: members7YbNs4BY4IMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editQEzhAHhKolMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editQEzhAHhKolMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editQEzhAHhKolMeta || {},
    alias: community_45profile_45editQEzhAHhKolMeta?.alias || [],
    redirect: community_45profile_45editQEzhAHhKolMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93eR1EVmDN7qMeta?.name ?? "community-profile-id",
    path: _91id_93eR1EVmDN7qMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93eR1EVmDN7qMeta || {},
    alias: _91id_93eR1EVmDN7qMeta?.alias || [],
    redirect: _91id_93eR1EVmDN7qMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communityDPzBhoFs3rMeta?.name ?? "community",
    path: communityDPzBhoFs3rMeta?.path ?? "/community",
    meta: communityDPzBhoFs3rMeta || {},
    alias: communityDPzBhoFs3rMeta?.alias || [],
    redirect: communityDPzBhoFs3rMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93mVTTTX3mLoMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93mVTTTX3mLoMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93mVTTTX3mLoMeta || {},
    alias: _91uuid_93mVTTTX3mLoMeta?.alias || [],
    redirect: _91uuid_93mVTTTX3mLoMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_937iz1DsLtHdMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_937iz1DsLtHdMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_937iz1DsLtHdMeta || {},
    alias: _91unique_id_937iz1DsLtHdMeta?.alias || [],
    redirect: _91unique_id_937iz1DsLtHdMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardeYD7KlgmvRMeta?.name ?? "dashboard",
    path: dashboardeYD7KlgmvRMeta?.path ?? "/dashboard",
    meta: dashboardeYD7KlgmvRMeta || {},
    alias: dashboardeYD7KlgmvRMeta?.alias || [],
    redirect: dashboardeYD7KlgmvRMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: index4lORKlFOthMeta?.name ?? "event-details-event_id",
    path: index4lORKlFOthMeta?.path ?? "/event/details/:event_id()",
    meta: index4lORKlFOthMeta || {},
    alias: index4lORKlFOthMeta?.alias || [],
    redirect: index4lORKlFOthMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutYKHrWFyUQnMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutYKHrWFyUQnMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutYKHrWFyUQnMeta || {},
    alias: checkoutYKHrWFyUQnMeta?.alias || [],
    redirect: checkoutYKHrWFyUQnMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productsfAxuzVWshMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productsfAxuzVWshMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productsfAxuzVWshMeta || {},
    alias: select_45productsfAxuzVWshMeta?.alias || [],
    redirect: select_45productsfAxuzVWshMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsj4aViZf72UMeta?.name ?? "events",
    path: eventsj4aViZf72UMeta?.path ?? "/events",
    meta: eventsj4aViZf72UMeta || {},
    alias: eventsj4aViZf72UMeta?.alias || [],
    redirect: eventsj4aViZf72UMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93CqbVZq0IxSMeta?.name ?? "gifts-uuid",
    path: _91uuid_93CqbVZq0IxSMeta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93CqbVZq0IxSMeta || {},
    alias: _91uuid_93CqbVZq0IxSMeta?.alias || [],
    redirect: _91uuid_93CqbVZq0IxSMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexGg6gIcMm8fMeta?.name ?? "gifts",
    path: indexGg6gIcMm8fMeta?.path ?? "/gifts",
    meta: indexGg6gIcMm8fMeta || {},
    alias: indexGg6gIcMm8fMeta?.alias || [],
    redirect: indexGg6gIcMm8fMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93hPSKtLo6kOMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93hPSKtLo6kOMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93hPSKtLo6kOMeta || {},
    alias: _91invitation_id_93hPSKtLo6kOMeta?.alias || [],
    redirect: _91invitation_id_93hPSKtLo6kOMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_938jeZFQLGgJMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_938jeZFQLGgJMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_938jeZFQLGgJMeta || {},
    alias: _91product_id_938jeZFQLGgJMeta?.alias || [],
    redirect: _91product_id_938jeZFQLGgJMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexXrRj4qsflmMeta?.name ?? "index",
    path: indexXrRj4qsflmMeta?.path ?? "/",
    meta: indexXrRj4qsflmMeta || {},
    alias: indexXrRj4qsflmMeta?.alias || [],
    redirect: indexXrRj4qsflmMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93MKaT8LNQkUMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93MKaT8LNQkUMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93MKaT8LNQkUMeta || {},
    alias: _91invitation_unique_id_93MKaT8LNQkUMeta?.alias || [],
    redirect: _91invitation_unique_id_93MKaT8LNQkUMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joingXzqQKG3RiMeta?.name ?? "join",
    path: joingXzqQKG3RiMeta?.path ?? "/join",
    meta: joingXzqQKG3RiMeta || {},
    alias: joingXzqQKG3RiMeta?.alias || [],
    redirect: joingXzqQKG3RiMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginyzzPRVXq9RMeta?.name ?? "login",
    path: loginyzzPRVXq9RMeta?.path ?? "/login",
    meta: loginyzzPRVXq9RMeta || {},
    alias: loginyzzPRVXq9RMeta?.alias || [],
    redirect: loginyzzPRVXq9RMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutUIflEFpIHeMeta?.name ?? "logout",
    path: logoutUIflEFpIHeMeta?.path ?? "/logout",
    meta: logoutUIflEFpIHeMeta || {},
    alias: logoutUIflEFpIHeMeta?.alias || [],
    redirect: logoutUIflEFpIHeMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93TKH1HPUyNtMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93TKH1HPUyNtMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93TKH1HPUyNtMeta || {},
    alias: _91meeting_type_slug_93TKH1HPUyNtMeta?.alias || [],
    redirect: _91meeting_type_slug_93TKH1HPUyNtMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93pknFv9nzPCMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93pknFv9nzPCMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93pknFv9nzPCMeta || {},
    alias: _91meeting_unique_id_93pknFv9nzPCMeta?.alias || [],
    redirect: _91meeting_unique_id_93pknFv9nzPCMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93MCTrRRgsuoMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93MCTrRRgsuoMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93MCTrRRgsuoMeta || {},
    alias: _91meeting_unique_id_93MCTrRRgsuoMeta?.alias || [],
    redirect: _91meeting_unique_id_93MCTrRRgsuoMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favoritesBCJwDKblt9Meta?.name ?? "my-favorites",
    path: my_45favoritesBCJwDKblt9Meta?.path ?? "/my-favorites",
    meta: my_45favoritesBCJwDKblt9Meta || {},
    alias: my_45favoritesBCJwDKblt9Meta?.alias || [],
    redirect: my_45favoritesBCJwDKblt9Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studios3PaVj4A80GMeta?.name ?? "my-studios",
    path: my_45studios3PaVj4A80GMeta?.path ?? "/my-studios",
    meta: my_45studios3PaVj4A80GMeta || {},
    alias: my_45studios3PaVj4A80GMeta?.alias || [],
    redirect: my_45studios3PaVj4A80GMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optin4yTwwOkDYGMeta?.name ?? "optin",
    path: optin4yTwwOkDYGMeta?.path ?? "/optin",
    meta: optin4yTwwOkDYGMeta || {},
    alias: optin4yTwwOkDYGMeta?.alias || [],
    redirect: optin4yTwwOkDYGMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_935DspaXXHoDMeta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_935DspaXXHoDMeta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_935DspaXXHoDMeta || {},
    alias: _91episode_id_935DspaXXHoDMeta?.alias || [],
    redirect: _91episode_id_935DspaXXHoDMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexalJQC5pwy5Meta?.name ?? "podcasts-podcast_id",
    path: indexalJQC5pwy5Meta?.path ?? "/podcasts/:podcast_id()",
    meta: indexalJQC5pwy5Meta || {},
    alias: indexalJQC5pwy5Meta?.alias || [],
    redirect: indexalJQC5pwy5Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: indexsZQnbSeeBEMeta?.name ?? "podcasts",
    path: indexsZQnbSeeBEMeta?.path ?? "/podcasts",
    meta: indexsZQnbSeeBEMeta || {},
    alias: indexsZQnbSeeBEMeta?.alias || [],
    redirect: indexsZQnbSeeBEMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93J108071pefMeta?.name ?? "product-product_id",
    path: _91product_id_93J108071pefMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93J108071pefMeta || {},
    alias: _91product_id_93J108071pefMeta?.alias || [],
    redirect: _91product_id_93J108071pefMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutrCaMzfsNVHMeta?.name ?? "product-product_id-about",
    path: aboutrCaMzfsNVHMeta?.path ?? "about",
    meta: aboutrCaMzfsNVHMeta || {},
    alias: aboutrCaMzfsNVHMeta?.alias || [],
    redirect: aboutrCaMzfsNVHMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentudXFiUQ3mhMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentudXFiUQ3mhMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentudXFiUQ3mhMeta || {},
    alias: digital_45download_45contentudXFiUQ3mhMeta?.alias || [],
    redirect: digital_45download_45contentudXFiUQ3mhMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: events4U6Db5nyvrMeta?.name ?? "product-product_id-events",
    path: events4U6Db5nyvrMeta?.path ?? "events",
    meta: events4U6Db5nyvrMeta || {},
    alias: events4U6Db5nyvrMeta?.alias || [],
    redirect: events4U6Db5nyvrMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93KoAH2D23aEMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93KoAH2D23aEMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93KoAH2D23aEMeta || {},
    alias: _91media_id_93KoAH2D23aEMeta?.alias || [],
    redirect: _91media_id_93KoAH2D23aEMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleVqI7q9YgXLMeta?.name ?? "product-product_id-free-sample",
    path: free_45sampleVqI7q9YgXLMeta?.path ?? "free-sample",
    meta: free_45sampleVqI7q9YgXLMeta || {},
    alias: free_45sampleVqI7q9YgXLMeta?.alias || [],
    redirect: free_45sampleVqI7q9YgXLMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsXfvIAcT4AKMeta?.name ?? "product-product_id-included-products",
    path: included_45productsXfvIAcT4AKMeta?.path ?? "included-products",
    meta: included_45productsXfvIAcT4AKMeta || {},
    alias: included_45productsXfvIAcT4AKMeta?.alias || [],
    redirect: included_45productsXfvIAcT4AKMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93Q0AJz1FjfWMeta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93Q0AJz1FjfWMeta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93Q0AJz1FjfWMeta || {},
    alias: _91media_id_93Q0AJz1FjfWMeta?.alias || [],
    redirect: _91media_id_93Q0AJz1FjfWMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewGJIjzGYXvaMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewGJIjzGYXvaMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewGJIjzGYXvaMeta || {},
    alias: viewGJIjzGYXvaMeta?.alias || [],
    redirect: viewGJIjzGYXvaMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexauZh1NbPBoMeta?.name ?? "product-product_id-lessons",
    path: indexauZh1NbPBoMeta?.path ?? "lessons",
    meta: indexauZh1NbPBoMeta || {},
    alias: indexauZh1NbPBoMeta?.alias || [],
    redirect: indexauZh1NbPBoMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93iIA8gAyGOeMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93iIA8gAyGOeMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93iIA8gAyGOeMeta || {},
    alias: _91media_id_93iIA8gAyGOeMeta?.alias || [],
    redirect: _91media_id_93iIA8gAyGOeMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexhfgXg3LFa9Meta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexhfgXg3LFa9Meta?.path ?? "playlists/:playlist_id()",
    meta: indexhfgXg3LFa9Meta || {},
    alias: indexhfgXg3LFa9Meta?.alias || [],
    redirect: indexhfgXg3LFa9Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93gBGPbamUcqMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93gBGPbamUcqMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93gBGPbamUcqMeta || {},
    alias: _91media_id_93gBGPbamUcqMeta?.alias || [],
    redirect: _91media_id_93gBGPbamUcqMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index11O1lSxDKcMeta?.name ?? "product-product_id-playlists",
    path: index11O1lSxDKcMeta?.path ?? "playlists",
    meta: index11O1lSxDKcMeta || {},
    alias: index11O1lSxDKcMeta?.alias || [],
    redirect: index11O1lSxDKcMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsyna80S6NxEMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsyna80S6NxEMeta?.path ?? "private-sessions",
    meta: private_45sessionsyna80S6NxEMeta || {},
    alias: private_45sessionsyna80S6NxEMeta?.alias || [],
    redirect: private_45sessionsyna80S6NxEMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsgyuxGGeX8cMeta?.name ?? "product-product_id-recordings",
    path: recordingsgyuxGGeX8cMeta?.path ?? "recordings",
    meta: recordingsgyuxGGeX8cMeta || {},
    alias: recordingsgyuxGGeX8cMeta?.alias || [],
    redirect: recordingsgyuxGGeX8cMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewsC5RF2ip1XAMeta?.name ?? "product-product_id-reviews",
    path: reviewsC5RF2ip1XAMeta?.path ?? "reviews",
    meta: reviewsC5RF2ip1XAMeta || {},
    alias: reviewsC5RF2ip1XAMeta?.alias || [],
    redirect: reviewsC5RF2ip1XAMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexV1EeS9Hd2sMeta?.name ?? "product",
    path: indexV1EeS9Hd2sMeta?.path ?? "/product",
    meta: indexV1EeS9Hd2sMeta || {},
    alias: indexV1EeS9Hd2sMeta?.alias || [],
    redirect: indexV1EeS9Hd2sMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexbgngeomjnfMeta?.name ?? "profile",
    path: indexbgngeomjnfMeta?.path ?? "/profile",
    meta: indexbgngeomjnfMeta || {},
    alias: indexbgngeomjnfMeta?.alias || [],
    redirect: indexbgngeomjnfMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesr7oZrAzr8gMeta?.name ?? "profile-purchases",
    path: purchasesr7oZrAzr8gMeta?.path ?? "/profile/purchases",
    meta: purchasesr7oZrAzr8gMeta || {},
    alias: purchasesr7oZrAzr8gMeta?.alias || [],
    redirect: purchasesr7oZrAzr8gMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptions1PNAbFbbMNMeta?.name ?? "profile-redemptions",
    path: redemptions1PNAbFbbMNMeta?.path ?? "/profile/redemptions",
    meta: redemptions1PNAbFbbMNMeta || {},
    alias: redemptions1PNAbFbbMNMeta?.alias || [],
    redirect: redemptions1PNAbFbbMNMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93dgPrZg83ICMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93dgPrZg83ICMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93dgPrZg83ICMeta || {},
    alias: _91quiz_id_93dgPrZg83ICMeta?.alias || [],
    redirect: _91quiz_id_93dgPrZg83ICMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_93AiLfrqyh9LMeta?.name ?? "reset-password-uid-token",
    path: _91token_93AiLfrqyh9LMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_93AiLfrqyh9LMeta || {},
    alias: _91token_93AiLfrqyh9LMeta?.alias || [],
    redirect: _91token_93AiLfrqyh9LMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetI0WxsnQoNCMeta?.name ?? "reset",
    path: resetI0WxsnQoNCMeta?.path ?? "/reset",
    meta: resetI0WxsnQoNCMeta || {},
    alias: resetI0WxsnQoNCMeta?.alias || [],
    redirect: resetI0WxsnQoNCMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shopBi6fA9lxDtMeta?.name ?? "shop",
    path: shopBi6fA9lxDtMeta?.path ?? "/shop",
    meta: shopBi6fA9lxDtMeta || {},
    alias: shopBi6fA9lxDtMeta?.alias || [],
    redirect: shopBi6fA9lxDtMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupBKyjn8Gi5dMeta?.name ?? "signup",
    path: signupBKyjn8Gi5dMeta?.path ?? "/signup",
    meta: signupBKyjn8Gi5dMeta || {},
    alias: signupBKyjn8Gi5dMeta?.alias || [],
    redirect: signupBKyjn8Gi5dMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveAT48POuDjZMeta?.name ?? "streaming-event_id-live",
    path: liveAT48POuDjZMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveAT48POuDjZMeta || {},
    alias: liveAT48POuDjZMeta?.alias || [],
    redirect: liveAT48POuDjZMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipsN0u4O29FjtMeta?.name ?? "tips",
    path: tipsN0u4O29FjtMeta?.path ?? "/tips",
    meta: tipsN0u4O29FjtMeta || {},
    alias: tipsN0u4O29FjtMeta?.alias || [],
    redirect: tipsN0u4O29FjtMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93diuEmgQFeoMeta?.name ?? "waiver-uuid",
    path: _91uuid_93diuEmgQFeoMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93diuEmgQFeoMeta || {},
    alias: _91uuid_93diuEmgQFeoMeta?.alias || [],
    redirect: _91uuid_93diuEmgQFeoMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactH1bMVuDzrfMeta?.name ?? "widgets-calendars-compact",
    path: compactH1bMVuDzrfMeta?.path ?? "/widgets/calendars/compact",
    meta: compactH1bMVuDzrfMeta || {},
    alias: compactH1bMVuDzrfMeta?.alias || [],
    redirect: compactH1bMVuDzrfMeta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullziN9pvRiN8Meta?.name ?? "widgets-calendars-full",
    path: fullziN9pvRiN8Meta?.path ?? "/widgets/calendars/full",
    meta: fullziN9pvRiN8Meta || {},
    alias: fullziN9pvRiN8Meta?.alias || [],
    redirect: fullziN9pvRiN8Meta?.redirect,
    component: () => import("/tmp/build_d5a8d3bb/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]